export default "/images/ic-template-card.svg?115d6834c72e0463525fffe19ce94fd4";